// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import fetchWithAuth from '../utils/fetchWithAuth.ts';
import { apiConfig } from '../config.js';
import { HiOutlineCog } from 'react-icons/hi';
import { useToast } from '../context/ToastContext.tsx';

const RecipeOptionsMenu = ({ recipeId }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [menuMode, setMenuMode] = useState('main'); // 'main' or 'confirm'
  const navigate = useNavigate();
  const menuRef = useRef();
  const { showToast } = useToast();

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showMenu && menuRef.current && !menuRef.current.contains(e.target)) {
        if (menuMode === 'confirm') {
          setMenuMode('main');
        } else {
          setShowMenu(false);
        }
        e.stopPropagation();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu, menuMode]);

  const handleDelete = async () => {
    try {
      await fetchWithAuth(`/api/recipes/${recipeId}`, {
        method: 'DELETE',
      });

      showToast({ message: 'Recipe deleted', type: 'success' }); // ✅ show success toast
      setShowMenu(false);
      setMenuMode('main');

      // Optional: Delay to let user see toast before reload
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (err) {
      console.error('Error deleting recipe:', err);
      showToast({ message: 'Error deleting recipe', type: 'error' }); // optional error toast
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        className="text-gray-500 hover:text-gray-700 text-xl"
        onClick={() => {
          setShowMenu(true);
          setMenuMode('main');
        }}
      >
        <HiOutlineCog />
      </button>

      {showMenu && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-30 z-40"></div>
          <div className="fixed inset-0 flex items-end justify-center z-50 mb-12 pb-4">
            <div
              ref={menuRef}
              className="bg-white w-full max-w-xs rounded-t-lg shadow-lg p-4 text-center"
            >
              {menuMode === 'main' ? (
                <>
                  <button
                    onClick={() => {
                      setShowMenu(false);
                      navigate(`/app/edit-recipe/${recipeId}`);
                    }}
                    className="block w-full text-center px-3 py-2 mb-2"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => setMenuMode('confirm')}
                    className="block w-full text-center px-3 py-2 text-red-600"
                  >
                    Delete
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={handleDelete}
                    className="block w-full text-center px-4 py-2 bg-red-600 text-white rounded mb-2"
                  >
                    Confirm
                  </button>
                  <button
                    onClick={() => setMenuMode('main')}
                    className="block w-full text-center px-3 py-2 text-gray-600"
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RecipeOptionsMenu;
